module.exports = __webpack_public_path__ + "img/Monte_Kope_36.f0f08d02.jpg";